import { DropDownList, DropDownListChangeEvent, ListItemProps } from '@progress/kendo-react-dropdowns';
import { Label } from '@progress/kendo-react-labels';
import React from 'react';
import './DropDown.scss';

interface IDropdown {
  size: 'fullwidth' | 'large' | 'medium' | 'small'
  label?: any;
  value: any;
  listItems: any;
  onSelect: (event: DropDownListChangeEvent) => void;
  onBlur?: (event: DropDownListChangeEvent) => void;
  dataKey: string;
  textField: string;
  readOnly?: boolean;
  idName?: string;
  prefix?: any;
  required?: boolean;
  listSize?: 'large' | 'regular'
}

/**
 *
 * @param size string - 'fullwidth', 'large', 'medium', 'small'
 * @param label string - Label to show above the combobox and default value in select box. Words "Select" added automatically ex: "Title"
 * @param listItems array - List of items you want to show in the combobox [{text: "", id: 1}]
 * @param onSelect function - function that accepts in a listItem returns void
 * @returns Dropdown combo box allows typing with autocomplete
 */
function DropDown(props: IDropdown) {
  let computedStyle;
  if (props.size === "fullwidth") {
    computedStyle = { width: "100%" }
  } else if (props.size === "large") {
    computedStyle = { width: "60%" }
  } else if (props.size === "medium") {
    computedStyle = { width: "40%" }
  } else {
    computedStyle = { width: "30%" }
  }

  const itemRender = (
    li: React.ReactElement<HTMLElement>,
    itemProps: ListItemProps
  ) => {
    const id = itemProps.dataItem[`${props.idName}`];
    const itemChildren = (
      <span>
        {
          props.prefix ?
            props.prefix + " " + id ?
              id + ": " + itemProps.dataItem[`${props.textField}`] :
              itemProps.dataItem[`${props.textField}`] :
            id ?
              id + ": " + itemProps.dataItem[`${props.textField}`] :
              itemProps.dataItem[`${props.textField}`]
        }

      </span>
    );
    return React.cloneElement(li, li.props, itemChildren)
  };

  const valueRender = (element: React.ReactElement<HTMLSpanElement>, value: any) => {
    if (!value) {
      return element;
    }
    const children: any = [
      <span key={1}>{value[`${props.idName ?? null}`]}</span>,
      <span key={2}>&nbsp;{value[`${props.textField}`]}</span>
    ]
    return React.cloneElement(element, { ...element.props }, children);
  }

  return (
    <div className="drop-down">
      {props.label ? (
        <Label className={props.required ? 'k-required' : ''} editorId={props.textField}>Select {props.label}</Label>
      ) : null}
      <DropDownList
        id={props.textField}
        style={computedStyle}
        value={props.value ?? null}
        data={props.listItems.length > 0 ? props.listItems : []}
        dataItemKey={props.dataKey}
        textField={props.textField}
        size="medium"
        onChange={(item: any) => { props.onSelect(item) }}
        disabled={props.readOnly ?? false}
        itemRender={itemRender}
        valueRender={valueRender}
        ariaLabel={`${props.textField} drop down`}
        onBlur={(item: any) => { props.onBlur?.(item)}}
        valid={
          props.required ?
            props.value.id !== undefined ? true : false :
            true
        }
        popupSettings={!!props.listSize && props.listSize === 'large' ? {className:'dropdown-height'} : {}}
      />
    </div >
  )
}

export default DropDown